import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, ArrowRight, Sparkles } from "lucide-react";

/**
 * Compact IT Support teaser — insert mid-page on service pages.
 * variant controls the context-specific hook.
 */
const ITSupportTeaser = ({ variant = "generic" }) => {
  const copy = {
    diensten: {
      eyebrow: "Alles-in-1",
      title: "Vaker een computerprobleem? Ontzorg uzelf met een abonnement.",
      body: "Onze meest gekozen klanten hebben een IT Support-abonnement. Bitdefender, onderhoud en onbeperkte hulp op afstand — voor één vaste maandprijs.",
    },
    reparaties: {
      eyebrow: "Bespaar structureel",
      title: "Vaak deze reparatie? Word IT Support-klant en bespaar.",
      body: "Onze IT Support-klanten hebben zelden nog reparaties nodig. Wij voorkomen problemen vóór ze optreden — voor de prijs van één reparatie per jaar.",
    },
    afstand: {
      eyebrow: "Onbeperkt geholpen",
      title: "Vaker snel geholpen willen worden? Met een abonnement is dit onbeperkt.",
      body: "IT Support-klanten bellen zo vaak als ze willen. Geen kosten per keer — gewoon één vast maandbedrag en direct hulp op afstand.",
    },
    generic: {
      eyebrow: "Ons meest gekozen product",
      title: "Wilt u volledig ontzorgd worden?",
      body: "Kies voor het IT Support-abonnement en laat computerproblemen aan ons over.",
    },
  }[variant] || null;

  const c = copy || {
    eyebrow: "Ons meest gekozen product",
    title: "Wilt u volledig ontzorgd worden?",
    body: "Kies voor het IT Support-abonnement en laat computerproblemen aan ons over.",
  };

  return (
    <section className="py-14 bg-gradient-to-br from-amber-50 via-white to-amber-50" data-testid={`its-teaser-${variant}`}>
      <div className="max-w-[1280px] mx-auto px-5 md:px-10">
        <div className="relative bg-white border-2 border-amber-400 shadow-lg overflow-hidden">
          {/* Amber accent stripe */}
          <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-amber-500"></div>

          <div className="grid md:grid-cols-[1fr_auto] items-center gap-8 p-7 md:p-10 pl-9 md:pl-14">
            <div>
              <div className="inline-flex items-center gap-2 bg-amber-100 border border-amber-200 text-amber-900 px-3 py-1 text-[11px] font-semibold tracking-widest uppercase mb-4">
                <Sparkles size={12} className="text-amber-600"/>
                {c.eyebrow}
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-neutral-900 mb-3 leading-tight">
                {c.title}
              </h3>
              <p className="text-neutral-600 leading-relaxed max-w-2xl">
                {c.body}
              </p>
              <div className="flex flex-wrap items-baseline gap-2 mt-5">
                <span className="text-3xl font-bold text-neutral-900">€15</span>
                <span className="text-sm text-neutral-500">/ maand</span>
                <span className="text-neutral-300">·</span>
                <span className="text-sm text-neutral-500">of <strong className="text-neutral-800">€150 / jaar</strong> — 2 maanden gratis</span>
              </div>
            </div>

            <div className="flex md:flex-col gap-3 shrink-0">
              <Link
                to="/it-support"
                data-testid={`its-teaser-cta-${variant}`}
                className="group inline-flex items-center justify-center gap-2 bg-neutral-900 hover:bg-black text-white px-6 py-3.5 text-[14px] font-semibold tracking-wide transition-colors whitespace-nowrap"
              >
                <ShieldCheck size={16}/>
                Bekijk abonnement
                <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform"/>
              </Link>
              <Link
                to="/zakelijk"
                className="inline-flex items-center justify-center gap-2 border border-neutral-300 hover:border-neutral-900 text-neutral-900 px-6 py-3.5 text-[14px] font-medium tracking-wide transition-colors whitespace-nowrap"
              >
                Voor bedrijven →
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ITSupportTeaser;
